export const MEDALLION_TYPES = {
  HUMAN: "HUMAN",
  PET: "PET"
};